import React from 'react';
import PropTypes from 'prop-types';
import { Button as SinkButton } from '@uncinc/uncinc-react-kitchen-sink';
import c from 'classnames';

import './style.scss';

const Button = ({ className = '', children, type, icon = '', iconLarge = false, ...props }) => {
  const classNames = c(className, `Button--${type || 'primary'}`, {
    'Button--icon-large': iconLarge && type,
  });

  const iconClassNames = c({
    icon: !type || (icon && type === 'secondary') || type === 'text',
    [`icon-${icon}`]: icon && type,
    'icon-arrow-right': !icon,
    'icon-variant-2': !type,
    'icon-variant-3': type === 'text',
  });

  return (
    <SinkButton primary={false} className={classNames} {...props}>
      { children }
      <div className={iconClassNames} />
    </SinkButton>
  );
};

Button.defaultProps = {
  type: null,
  icon: null,
  iconLarge: false,
};

Button.propTypes = {
  type: PropTypes.string,
  icon: PropTypes.string,
  iconLarge: PropTypes.bool,
};

export default Button;
